import { createConsumer } from '@rails/actioncable';

const PRESENCE_INTERVAL = 20000;

class BaseActionCableConnector {
  constructor(
    app,
    pubsubToken,
    websocketHost = '',
    presenceInterval = PRESENCE_INTERVAL
  ) {
    this.app = app;
    this.events = {};
    this.isAValidEvent = () => true;
    this.disposed = false;
    this.disconnected = false;
    this.presenceTimer = null;
    this.presenceInterval = presenceInterval;
    this.consumer = createConsumer(
      websocketHost ? `${websocketHost}/cable` : undefined
    );
    this.subscription = this.consumer.subscriptions.create(
      {
        channel: 'RoomChannel',
        pubsub_token: pubsubToken,
        account_id: app.$store.getters.getCurrentAccountId,
        user_id: app.$store.getters.getCurrentUserID,
      },
      this.subscriptionCallbacks()
    );
  }

  subscriptionCallbacks() {
    return {
      updatePresence() {
        this.perform('update_presence');
      },
      received: this.onReceived,
      connected: this.subscriptionConnected,
      disconnected: this.subscriptionDisconnected,
      rejected: this.subscriptionDisconnected,
    };
  }

  subscriptionConnected = () => {
    if (this.disposed) return;
    this.schedulePresence();
    if (!this.disconnected) return;
    this.disconnected = false;
    this.onReconnect();
  };

  subscriptionDisconnected = () => {
    clearTimeout(this.presenceTimer);
    if (this.disposed || this.disconnected) return;
    this.disconnected = true;
    this.onDisconnected();
  };

  schedulePresence = () => {
    clearTimeout(this.presenceTimer);
    this.presenceTimer = setTimeout(() => {
      if (this.disposed || this.disconnected) return;
      this.subscription.updatePresence();
      this.schedulePresence();
    }, this.presenceInterval);
  };

  onReconnect = () => {};

  onDisconnected = () => {};

  disconnect() {
    this.disposed = true;
    clearTimeout(this.presenceTimer);
    this.subscription.unsubscribe?.();
    this.consumer.disconnect();
  }

  onReceived = ({ event, data } = {}) => {
    if (
      !this.disposed &&
      this.isAValidEvent(data) &&
      typeof this.events[event] === 'function'
    ) {
      this.events[event](data);
    }
  };
}

export default BaseActionCableConnector;
